module.exports = __webpack_public_path__ + "24d78cdc907f7a12f4aa139559fa4d14.svg";